module.exports = " <blnd-activity object=\"vmo.ticket\"></blnd-activity>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/tickets/templates/detail.log.html
// module id = 686
// module chunks = 0